// ** React Imports
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const UserList = lazy(() => import('../../views/users/list'));
const UserView = lazy(() => import('../../views/users/view'));

const UsersRoutes = [
  {
    element: <UserList />,
    path: '/users/list',
    meta: {
      permission: 'USERS'
    }
  },
  {
    path: '/users/view',
    element: <Navigate to="/users/list" />,
    meta: {
      permission: 'USERS'
    }
  },
  {
    element: <UserView />,
    path: '/users/view/:id',
    meta: {
      permission: 'USERS'
    }
  }
];

export default UsersRoutes;
